import { BillableShiftModel } from "@core/models/back-office/billable-shifts/billable-shifts.model";
import { BILLABLE_SHIFTS_PLATFORMS, BILLABLE_SESSION_TYPES } from "@core/constants";

export const IBillingSessionCreation = Object.freeze({
  comment: "comment",
  date: "date",
  datePayment: "payment_date",
  shifts: "shifts",
  submitted: "submitted",
  billingPlatform: "billing_platform",
  billingType: "bill_type",
});

export class BillingSessionCreationModel {
  constructor(data = {}) {
    this[IBillingSessionCreation.comment] = data[IBillingSessionCreation.comment] || "";
    this[IBillingSessionCreation.date] = data[IBillingSessionCreation.date] || null;
    this[IBillingSessionCreation.datePayment] = data[IBillingSessionCreation.datePayment] || null;
    this[IBillingSessionCreation.shifts] = data[IBillingSessionCreation.shifts] || [];
    this[IBillingSessionCreation.submitted] = data[IBillingSessionCreation.submitted] === true;
    this[IBillingSessionCreation.billingPlatform] = data[IBillingSessionCreation.billingPlatform] || BILLABLE_SHIFTS_PLATFORMS.STRIPE;
    this[IBillingSessionCreation.billingType] = data[IBillingSessionCreation.billingType] || BILLABLE_SESSION_TYPES.ETAB;
  }

  getCommentLength() {
    return 255;
  }

  isBillingPlatformValid() {
    return this[IBillingSessionCreation.billingPlatform];
  }

  isBillingTypeValid() {
    return this[IBillingSessionCreation.billingType];
  }

  dateIsValid() {
    return this[IBillingSessionCreation.date] !== null;
  }

  datePaymentIsValid() {
    return this[IBillingSessionCreation.datePayment] !== null;
  }

  commentIsValid() {
    return this[IBillingSessionCreation.comment]?.length <= this.getCommentLength();
  }

  isValid() {
    return this.isBillingTypeValid() && this.isBillingPlatformValid() && this.dateIsValid() && this.datePaymentIsValid() && this.commentIsValid();
  }

  getShifts() {
    return this[IBillingSessionCreation.shifts].map((s) => new BillableShiftModel(s));
  }

  setShifts(shifts = []) {
    this[IBillingSessionCreation.shifts] = [...shifts];
  }

  setSubmitted() {
    this[IBillingSessionCreation.submitted] = true;
  }

  isSubmitted() {
    return this[IBillingSessionCreation.submitted] === true;
  }
}
